import { playSfx } from 'shared-base';

export function* playKeyframeSfx(keyframe: IKeyframe) {
  const { valuesKeyframe: values } = keyframe;
  playSfx(values.src as string);
}
